import React from 'react';
import { palette } from '../../design-system/colors';
import { useTranslation } from 'react-i18next';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
    priorityDisclaimer: {
        color: palette.graphite.onyx,
        fontSize: '12px',
        fontWeight: '400',
        padding: '2px',
        backgroundColor: palette.graphite.gray,
        borderRadius: '2px',
    },

    priorityIcon: {
        color: palette.graphite.ash,
        marginLeft: '4px',
        marginRight: '8px',
        marginBottom: '2px',
        fontSize: '16px',
    },
}));

const EmailPriorityDisclaimer = ({}) => {
    const { t } = useTranslation('assessment');
    const classes = useStyles();

    return (
        <div className={classes.priorityDisclaimer}>
            <ErrorOutlineOutlinedIcon className={classes.priorityIcon} />
            {t('This message is high priority')}
        </div>
    );
};

export default EmailPriorityDisclaimer;
